import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Checkbox, Form, Label } from 'semantic-ui-react'
import axios from 'axios';
import './style.css'

export default function Update() {
	
	const navigate  = useNavigate();
	
	const [id, setId] = useState('');
	const [hunterId, setHunterId] = useState('');
	const [marka, setMarka] = useState('');
	const [kalibar, setKalibar] = useState('');
	const [serijskibroj, setSerijskiBroj] = useState('');
	const [oruznilist, setOruzniList] = useState('');
	const [mup, setMUP] = useState('');
	const [photo, setPhoto] = useState('');
	
	useEffect(() => {
        setHunterId(localStorage.getItem('hunterId'))
	}, []);
	
	const updateAPIData = () => {
		axios.post(`http://89.46.196.228:3000/api/rifles`,
			{
				"hunterId": hunterId,
				"marka": marka,
				"kalibar": kalibar,
				"serijskibroj": serijskibroj,
				"oruznilist": oruznilist,
				"mup": mup,
				"photo": photo
			}
			).then(() => {
            navigate('/SLOBiHClanovi')
        })
    }

    return (
	    <div className="main">
        <div>
            <Form className="create-form">
				<Form.Field>
                    <Label>Maticni broj</Label>
                    <input placeholder='Hunter Id' value={hunterId} onChange={(e) => setHunterId(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Ime</Label>
                    <input placeholder='Ime' value={marka} onChange={(e) => setMarka(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Prezime</Label>
                    <input placeholder='Prezime' value={kalibar} onChange={(e) => setKalibar(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Adresa</Label>
                    <input placeholder='Adresa' value={serijskibroj} onChange={(e) => setSerijskiBroj(e.target.value)}/>
                </Form.Field>
				
			    <Form.Field>
                    <Label>Telefon</Label>
                    <input placeholder='Telefon' value={oruznilist} onChange={(e) => setOruzniList(e.target.value)}/>
                </Form.Field>
				
				<Form.Field>
                    <Label>Telefon</Label>
                    <input placeholder='Telefon' value={mup} onChange={(e) => setMUP(e.target.value)}/>
                </Form.Field>
				
                <Button onClick={updateAPIData} type='submit'>Submit</Button>
            </Form>
        </div>
		</div>
    )
}